import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { DeleteOutlined, AddOutlined } from '@material-ui/icons';
import { selectedOrganizationSelector } from '../../../redux/selectors/organization';
import {
  Group,
  Container,
  Tab,
  ExportBtn,
  DownloadIcon,
  Row,
  Button,
  AddButton,
} from './Tabs.styled';
import {
  GENERAL_INFO,
  USERS,
  AMS_SYNC,
  PREFERENCE_PAGE,
  NONMEMBER_SIGNUP_FORM,
} from './constants';
import { useIsFeatureEnabled } from '../../../libs/feature-toggles/react';
import Feature from '../../../infrastructure/features';

const Tabs = ({
  selectedTab,
  onSelectTab,
  csvUserData,
  setDeleteUserModalVisibility,
  isDeleteUserBtnDisabledRef,
  setAddUserDrawerVisibility,
}) => {
  const isnonMemberSignUpEnabled = useIsFeatureEnabled(
    Feature.NON_MEMBER_SIGNUP
  );
  const TABS = [
    GENERAL_INFO,
    USERS,
    AMS_SYNC,
    PREFERENCE_PAGE,
    ...(isnonMemberSignUpEnabled ? [NONMEMBER_SIGNUP_FORM] : []),
  ];

  const selectedOrg = useSelector(selectedOrganizationSelector);

  const renderRightMenu = () => {
    switch (selectedTab) {
      case GENERAL_INFO:
        return <></>;
      case USERS:
        return (
          <Row>
            <CSVLink
              data={csvUserData}
              filename={`${
                selectedOrg.acronym
              } NR Users Export ${moment().format('MM-DD-YYYY')}`}
            >
              <ExportBtn>
                <DownloadIcon />
                Export
              </ExportBtn>
            </CSVLink>
            <Button
              onClick={() => setDeleteUserModalVisibility(true)}
              disabled={isDeleteUserBtnDisabledRef.current}
            >
              <DeleteOutlined />
            </Button>
            <AddButton
              onClick={() => {
                setAddUserDrawerVisibility(true);
              }}
            >
              <AddOutlined />
              Add
            </AddButton>
          </Row>
        );
      case AMS_SYNC:
        return <></>;
      case PREFERENCE_PAGE:
        return <></>;
      case NONMEMBER_SIGNUP_FORM:
        return <></>;
      default:
        return null;
    }
  };

  return (
    <Container>
      <Group>
        {TABS.map((tab, index) => (
          <Tab
            isActive={selectedTab === tab}
            key={index}
            onClick={() => onSelectTab(tab)}
          >
            {tab}
          </Tab>
        ))}
      </Group>
      <Group>{renderRightMenu()}</Group>
    </Container>
  );
};

export default Tabs;
